'use strict'

export const TWOPI = Math.PI*2
export const Y_AXIS = new THREE.Vector3(0, 1, 0)



/** WEBPACK FOOTER **
 ** ./src/lib/constants.js
 **/